// Single source of truth for the developer documentation host.
// Change DOCS_BASE_URL here rather than hardcoding the host anywhere else.
const DOCS_BASE_URL = "https://docs.insightiq.ai";
const docsRoot = `${DOCS_BASE_URL}/docs/api-reference`;
const operations = `${docsRoot}/api/ref/operations`;

const webhookUrl = "/developers/webhooks";
const updateWebhookPageUrl = "/developers/webhooks/edit";
const createWebhookPageUrl = "/developers/webhooks/create";

// docs landing page
const docs_home = `${docsRoot}/introduction/introduction`;

// introduction
const product = `${docsRoot}/introduction/products`;
const getting_started_apis = `${docsRoot}/introduction/getting-started-with-insightiq-APIs`;
const useful_terms = `${docsRoot}/introduction/important-and-useful-terms`;

// connect SDK
const web_integration = `${docsRoot}/connect-SDK/web/browser-integration`;
const ios_integration = `${docsRoot}/connect-SDK/mobile/ios-SDK-integration`;
const connect_sdk_start = `${docsRoot}/connect-SDK/getting-started-with-connect-SDK`;
const connect_sdk_flow = `${docsRoot}/connect-SDK/connect-SDK-flow`;
const connect_sdk_config = `${docsRoot}/connect-SDK/connect-SDK-configuration`;

// API guides
const product_APIs = `${docsRoot}/API/getting-started-with-APIs`;
const handling_errors = `${docsRoot}/API/handling-errors`;
const webhooks_guide = `${docsRoot}/API/webhooks-guide`;
const handling_webhooks = `${docsRoot}/guides/handling-insightiq-webhooks`;
const rate_limits = `${docsRoot}/guides/respecting-rate-limits`;

// API reference
const api_reference = `${docsRoot}/api/ref`;
const create_identifier = `${operations}/create-a-v-1-user`;
const generateToken = `${operations}/create-a-v-1-sdk-token`;
const profiles_api = `${operations}/list-v-1-profiles`;
const audience_api = `${operations}/get-a-v-1-audience`;
const contents_api = `${operations}/list-v-1-social-contents`;
const comments_api = `${operations}/list-v-1-social-comments`;
const income_api = `${operations}/list-v-1-social-income-transactions`;
const activity_api = `${operations}/list-v-1-media-activity-contents`;
const disconnect_api = `${operations}/create-a-v-1-account-disconnect`;

export {
  DOCS_BASE_URL,
  webhookUrl,
  updateWebhookPageUrl,
  createWebhookPageUrl,
  docs_home,
  product,
  getting_started_apis,
  useful_terms,
  web_integration,
  ios_integration,
  connect_sdk_start,
  connect_sdk_flow,
  connect_sdk_config,
  product_APIs,
  handling_errors,
  webhooks_guide,
  handling_webhooks,
  rate_limits,
  api_reference,
  create_identifier,
  generateToken,
  profiles_api,
  audience_api,
  contents_api,
  comments_api,
  income_api,
  activity_api,
  disconnect_api,
};
